module.exports = __webpack_public_path__ + "static/media/withoutNameEng.c9192a64.png";